/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedsusworkshopinnerstrenght4Inputs */

const de__field_participatedsusworkshopinnerstrenght4 = /** @type {(inputs: _Field_Participatedsusworkshopinnerstrenght4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an Sus WorkshopinnerStrenght`)
};

/**

* @param {_Field_Participatedsusworkshopinnerstrenght4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedsusworkshopinnerstrenght4 = /** @type {((inputs?: _Field_Participatedsusworkshopinnerstrenght4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedsusworkshopinnerstrenght4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedsusworkshopinnerstrenght4(inputs)
});
export { _field_participatedsusworkshopinnerstrenght4 as "_field_participatedSusWorkshopInnerStrenght" }